import { SafeArea, TabBar } from "antd-mobile";
import { AppOutline, UserOutline } from "antd-mobile-icons";
import { useEffect, useState } from "react";
import HomePage from "./HomePage";
import MyPage from "./MyPage";
import '../styles/MainPage.css';

// 登录后主应用组件，包含底部导航
const MainPage = () => {
    // 控制当前选中的导航项，初始为首页
    const [activeKey, setActiveKey] = useState('home');
    useEffect(() => {
        // 设置视口高度变量
        const setViewportHeight = () => {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        };

        setViewportHeight();
        window.addEventListener('resize', setViewportHeight);

        return () => window.removeEventListener('resize', setViewportHeight);
    }, []);
    let content;
    if (activeKey === 'home') {
        content = <HomePage />;
    } else if (activeKey === 'my') {
        content = <MyPage />;
    }
    return (
        <div className="page-container">
            <div className="page-content">
                {/* 主体内容区域 */}
                <div className="main-content">{content}</div>
                {/* 底部导航栏 */}
                <div className="tab-bar-container">
                    <TabBar activeKey={activeKey} onChange={(key) => setActiveKey(key)}>
                        <TabBar.Item key="home" icon={<AppOutline />} title="首页" />
                        <TabBar.Item key="my" icon={<UserOutline />} title="我的" />
                    </TabBar>
                    <SafeArea position='bottom' />
                </div>
            </div>
        </div>
    );
};
export default MainPage;